import { Box, Inline, Text } from 'braid-design-system';
import React from 'react';

export interface District {
  id: string;
  urlKey: string;
  displayTitle: string;
}

interface DistrictProps {
  districts: District[];
}

export const District = ({ districts }: DistrictProps) => {
  const districtTitles = districts.map((d) => d.displayTitle);

  let displayText = '';
  if (districtTitles.length === 1) {
    displayText = districtTitles.toString();
  } else if (districtTitles.length === 2) {
    displayText = districtTitles.join(' and ');
  } else {
    displayText = 'multiple locations';
  }

  return (
    <Inline space="xsmall">
      <Text weight="strong">Location:</Text>
      <Box data-testid="profile-saved-searches-location-display-text">
        <Text>in {displayText}</Text>
      </Box>
    </Inline>
  );
};
